import { doc, getDoc } from "@firebase/firestore";
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from "../../../../shared/snackbar/snackbar-slice";
import { setRentalItems } from "../../../request-rent/request-rent-slice";

export const getForRentWigsDetailsDataService = async (dispatch, db, coll, id) => {
    try {
        const docRef = doc(db, coll, id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            return docSnap.data();
        } else {
            dispatch(showWarningSnackbar("This document no longer exists."));
        }
    } catch(e) {
        dispatch(showErrorSnackbar('Fetch failed! Please try again.'))
        console.error("ForRentWigsDetails getForRentWigsDetailsDataService error: ", e);
    }
};

export const addItemToRent = async (dispatch, rentalItem) => {
    try {
        dispatch(setRentalItems(rentalItem));
        dispatch(showSuccessSnackbar('Added successfully!'));
    } catch(e) {
        dispatch(showErrorSnackbar('Add to rent failed! Please try again.'))
        console.error("ForRentWigsDetails addItemToRent error: ", e);
    }
}